import { SPFxAdalClient, DefaultRuntime, onRuntimeCreate, objectDefinedNotNull } from "@pnp/common";
onRuntimeCreate((runtime) => {
    const existing = runtime.get("graph");
    const graphPart = Object.assign({}, {
        fetchClientFactory: () => {
            // we keep a ref to the runtime within which we are assigned
            const context = runtime.get("spfxContext");
            if (objectDefinedNotNull(context)) {
                return new SPFxAdalClient(context);
            }
            throw Error("There is no Graph Client available, either set one using configuraiton or provide a valid SPFx Context.");
        },
    }, existing);
    runtime.assign({ graph: graphPart });
});
export function setup(config, runtime = DefaultRuntime) {
    runtime.assign(config);
}
//# sourceMappingURL=graphlibconfig.js.map